import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Spinner from '../../../../../Spinner/Spinner';
import WarningModal from '../../../../../WarningModal';
import { useUnifiedFetch } from '../../../../../../hooks';
import utils from '../../../../../../lib/utils';

const styles = {
  row: { marginTop: '15px' },
  span: { marginBottom: '15px' },
  tableRow: { backgroundColor: '#8080802e', width: '50%' },
};

function PreferredProviderTest({ boxVpnAddress, boxDC }) {
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [boxLoad, setBoxLoad] = useState(true);
  const [initiatedTimestamp, setInitiatedTimestamp] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const {
    isLoading: isTestInProgress,
    data: initiateTestResults,
    fetchData: initiateTest,
  } = useUnifiedFetch(`boxes/${boxVpnAddress}/initlteperfcheck`, false);
  const {
    isLoading: isFetchingTestResults,
    data: testResults,
    fetchData: fetchTestResults,
  } = useUnifiedFetch(`boxes/${boxVpnAddress}/fetchlteperf`, false, false);

  useEffect(() => {
    if (boxDC) {
      fetchTestResults();
    }
  }, [boxDC]);

  useEffect(() => {
    setInitiatedTimestamp(testResults?.initiateTimeStamp);
  }, [testResults]);

  useEffect(() => {
    if (initiateTestResults?.response) {
      setInitiatedTimestamp(initiateTestResults?.previousTest?.initiateTimeStamp);
    }
  }, [initiateTestResults]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (initiatedTimestamp) {
        const currentTime = new Date();
        const timeDifference = Math.floor((currentTime - new Date(initiatedTimestamp)) / 1000);
        if (timeDifference <= 0 || timeDifference >= 5 * 60) {
          setElapsedTime(null);
          setIsButtonDisabled(false);
          fetchTestResults();
        } else {
          setElapsedTime(timeDifference);
          setIsButtonDisabled(true);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [initiatedTimestamp]);

  const handleWarningConfirm = () => {
    setBoxLoad(false);
    initiateTest();
    setIsWarningModalOpen(false);
  };

  const handleWarningCancel = () => {
    setIsWarningModalOpen(false);
  };

  const formatTime = () => {
    if (elapsedTime === null) return '';
    const minFloor = Math.floor(elapsedTime / 60);
    const secondsRemainder = elapsedTime % 60;
    const minString = minFloor < 10 ? `0${minFloor}` : minFloor;
    const secString = secondsRemainder < 10 ? `0${secondsRemainder}` : secondsRemainder;
    return `${minString}:${secString}`;
  };

  const simsInfo = testResults?.SimsInfo || initiateTestResults?.previousTest?.SimsInfo;
  const timestamp = testResults?.TimeStamp || initiateTestResults?.previousTest?.TimeStamp;
  const formattedTimestamp = moment(timestamp).format('MM-DD-YYYY, h:mm a');

  return (
    <>
      <div className="containerTest">
        <div className="row" style={styles.row}>
          <div className="col-12" style={styles.span}>
            <span className="under-line font-weight-bold">Preferred LTE / Cell Provider Test</span>
          </div>
          <div className="col-12">
            {elapsedTime && (
              <div className="mb-1 conectionDetails">
                <h1>
                  {initiateTestResults?.response ||
                    `LTE performance check initiatied, please wait 5 minutes for it to be completed`}
                </h1>
              </div>
            )}
            {elapsedTime && <span>Time: {formatTime()}</span>}
          </div>
          <div className="col-12">
            {simsInfo && (
              <table className="table-condenced" style={{ borderCollapse: 'collapse' }}>
                {simsInfo.map(item => (
                  <>
                    <tr>
                      <td style={styles.tableRow}>SIM</td>
                      <td>{item.SIM}</td>
                    </tr>
                    <tr>
                      <td style={styles.tableRow}>PingAvg</td>
                      <td>{item.PingAvg}</td>
                    </tr>
                    <tr>
                      <td style={styles.tableRow}>PacketLoss</td>
                      <td>{item.PacketLoss}</td>
                    </tr>
                    <tr>
                      <td style={styles.tableRow}>Jitter</td>
                      <td>{item.Jitter}</td>
                    </tr>
                    <tr>
                      <td style={styles.tableRow}>Error</td>
                      <td>{item.Error}</td>
                    </tr>
                    <br />
                  </>
                ))}
                <tr>
                  <td style={styles.tableRow}>Timestamp</td>
                  <td>
                    <span style={timestamp && utils.isOlderThan24Hours(timestamp) ? { color: 'red', fontWeight: 500 } : {}}>
                      {formattedTimestamp}
                    </span>
                  </td>
                </tr>
                <br />
              </table>
            )}
          </div>
          <div className="col-12">
            <button
              onClick={() => {
                setIsWarningModalOpen(true);
              }}
              className="btn btn-primary btn-sm"
              disabled={isButtonDisabled}
            >
              Run
            </button>
          </div>
        </div>
        {isTestInProgress && <Spinner customText="Initiating preferred provider test…" />}
        {isFetchingTestResults && !boxLoad && (
          <Spinner customText="Fetching preferred provider test results…" />
        )}
      </div>
      {isWarningModalOpen && (
        <WarningModal
          isOpen={isWarningModalOpen}
          onConfirm={handleWarningConfirm}
          onCancel={handleWarningCancel}
          noButtonText="Close"
          yesButtonText="Continue"
        >
          Running the preferred provider test on LTE 4G only may result in a temporary loss of
          connectivity; proceed with caution.
        </WarningModal>
      )}
    </>
  );
}

export default PreferredProviderTest;